export default __webpack_public_path__ + "static/trace_02-f5e1f7bd820c8fd2742858c018e381fd.png";